import { render, staticRenderFns } from "./UserArticles.vue?vue&type=template&id=000f25e2&scoped=true"
import script from "./UserArticles.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserArticles.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./UserArticles.vue?vue&type=style&index=0&id=000f25e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000f25e2",
  null
  
)

export default component.exports